module.exports = __webpack_public_path__ + "static/media/ceuterraemar.b3fc8be1.png";